import { defineStore } from "pinia";

export const usePublicInfoStore = defineStore({
  id: "publicInfo",
  state: () => ({
    toggleList: [],
    toggleFeature: {
      message: "",
      name: "",
      status: false,
      startTime: null,
      endTime: null,
    },
    toggleGeneral: {},
    toggleFeatureError: false,

    banners: [],
    loadingGetBanner: false,
    errorGetBanner: false,

    layananList: [],
    loadingGetLayanan: false,
    errorGetLayanan: false,

    surveyInfo: {},
    loadingSurveyInfo: false,

    loadingOptInSurvey: false,
  }),
  getters: {
    isMaintenanceMode() {
      const start = new Date(usePublicInfoStore().toggleFeature.startTime);
      const end = new Date(usePublicInfoStore().toggleFeature.endTime);
      const now = new Date();
      const status = usePublicInfoStore().toggleFeature.status;
      return status && now >= start && now <= end;
    },
  },
  actions: {
    async getToggleFeature() {
      try {
        const response = await $fetch.raw(
          `${
            useRuntimeConfig().public.apiBelajarWajib
          }/public-info/api/maintenance/status`,
          {
            method: "GET",
          },
        );
        usePublicInfoStore().$patch((state) => {
          state.toggleGeneral = response?._data || {};
          state.toggleList = response?._data?.modules || [];
        });
        localStorage.setItem(
          "toggleList",
          JSON.stringify(response?._data?.modules || []),
        );
        this.toggleFeatureError = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.toggleFeatureError = true;
        }
      }
    },
    async getBanners() {
      try {
        this.loadingGetBanner = true;
        const response = await $fetch.raw(
          `${
            useRuntimeConfig().public.apiBelajarWajib
          }/public-info/api/public/banners`,
          {
            method: "GET",
          },
        );
        usePublicInfoStore().$patch((state) => {
          state.banners = response?._data?.data || [];
        });
        this.errorGetBanner = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const d = error?.response?._data;
          useAuthStore().$patch({
            snackStatus: "destructive",
            snackbar: true,
            messageSnack:
              d?.error || d?.message || "Terjadi kesalahan saat memuat banner.",
            isRevamp: true,
          });
        }
        this.errorGetBanner = true;
      } finally {
        this.loadingGetBanner = false;
      }
    },
    async getLayanan() {
      try {
        this.loadingGetLayanan = true;
        const response = await $fetch.raw(
          `${
            useRuntimeConfig().public.apiBelajarWajib
          }/public-info/api/public/layanan`,
          {
            method: "GET",
          },
        );
        usePublicInfoStore().$patch((state) => {
          state.layananList = response?._data?.data || [];
        });
        this.errorGetLayanan = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const d = error?.response?._data;
          useAuthStore().$patch({
            snackStatus: "destructive",
            snackbar: true,
            messageSnack:
              d?.error ||
              d?.message ||
              "Terjadi kesalahan saat memuat layanan.",
            isRevamp: true,
          });
        }
        this.errorGetLayanan = true;
      } finally {
        this.loadingGetLayanan = false;
      }
    },
    async getSurveyInfo() {
      this.loadingSurveyInfo = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          "/public-info/api/survey/user",
          "GET",
        );
        usePublicInfoStore().$patch((state) => {
          state.surveyInfo = response?.data || {};
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const d = error?.response?._data;
          useAuthStore().$patch({
            snackStatus: "destructive",
            snackbar: true,
            messageSnack:
              d?.error ||
              d?.message ||
              "Terjadi kesalahan saat memuat info survei.",
            isRevamp: true,
          });
        }
      } finally {
        this.loadingSurveyInfo = false;
      }
    },
    async optInSurvey(payload) {
      this.loadingOptInSurvey = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          "/public-info/api/survey/save",
          "POST",
          payload,
        );
        if (Object.keys(response).length > 0) {
          return navigateTo("/survei");
        }
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          const d = error?.response?._data;
          useAuthStore().$patch({
            snackStatus: "destructive",
            snackbar: true,
            messageSnack: d?.error || d?.message || "Terjadi kesalahan.",
            isRevamp: true,
          });
        }
      } finally {
        this.loadingOptInSurvey = false;
        await usePublicInfoStore().getSurveyInfo();
      }
    },
  },
});
